import React from 'react'
import { Card } from 'antd'
import { useParams } from 'react-router'
import fileDownload from 'js-file-download'
import { useSelector } from 'react-redux'
import DistributionBetweenPhasesChart from './DistributionBetweenPhasesChart'
import { useLazyExportDistributionBetweenPhasesQuery } from '../../../../../../../store/apis/analytics.api'
import assignmentSelectors from '../../../../../../../store/selectors/assignment.selectors'
import ExportDropdownButton from '../../../../../../../components/common/export/ExportDropdownButton'

const DistributionBetweenPhasesCard = ({ title = 'Distribution Between Phases', phasesToShow }) => {
    const { token } = useParams()

    const assignmentName = useSelector(assignmentSelectors.name)

    const [exportDistributionBetweenPhases, exportResult] = useLazyExportDistributionBetweenPhasesQuery()

    const handleExport = async () => {
        const response = await exportDistributionBetweenPhases({ token, phasesToShow })

        if ('data' in response) {
            fileDownload(response.data, `${assignmentName}_distribution_between_phases.xlsx`)
        }
    }

    const extra = (
        <ExportDropdownButton
            onExport={handleExport}
            formats={['xlsx']}
            loading={exportResult.isLoading}
            buttonText='Export'
        />
    )

    return (
        <Card title={title} extra={extra}>
            <DistributionBetweenPhasesChart token={token} phasesToShow={phasesToShow} />
        </Card>
    )
}

export default DistributionBetweenPhasesCard
